import { useSelector } from "react-redux";
import { useState,useEffect } from "react";
import styles from './PrintLink.module.css';

const PrintLink = ({ onClick }) => {

    const [isLoading, setIsLoading] = useState(false);
    const activePattern = useSelector((state) => state.visualizer.activePattern);
    const selectedSlotProducts = useSelector((state) => state.visualizer.selectedSlotProducts);


    const handleClick = async () => {
        setIsLoading(true);

        try {
            if (!activePattern) {
                console.error('No active pattern selected');
                setIsLoading(false);
                return;
            }

            // Get pattern ID from the id attribute
            const patternId = activePattern.id || activePattern.patternId || '';
            
            if (!patternId) {
                console.error('Pattern ID not found in pattern object:', activePattern);
                setIsLoading(false);
                return;
            }

            // Get selected product IDs
            const productIds = [];
            if (activePattern.descriptor) {
                const colorSlots = activePattern.descriptor.split(',').map(slot => slot.trim());
                colorSlots.forEach((slot, index) => {
                    const product = selectedSlotProducts[index];
                    if (product && product.id) {
                        productIds.push(product.id);
                    } else {
                        productIds.push('-1'); // Placeholder for empty slots
                    }
                });
            }

            // Generate selection parameter: patternid(product1,product2,product3,...)
            const selectionParam = `${patternId}(${productIds.join(',')})`;
            
            // Generate print URL - use absolute path from root
            const printUrl = `/print.html?selection=${encodeURIComponent(selectionParam)}`;
            
            console.log('Opening print page with URL:', printUrl);
            console.log('Pattern ID:', patternId);
            console.log('Product IDs:', productIds);
            console.log('Selection parameter:', selectionParam);
            
            // Open in new tab
            window.open(printUrl, '_blank');
            
            // Call the optional onClick callback (e.g., to close menu)
            if (onClick) {
                onClick();
            }
            
        } catch (error) {
            console.error('Error opening print page:', error);
        } finally {
            setIsLoading(false);
        }
    };





    useEffect(() => {
        
        if(localStorage.getItem("REDIRECT_ACTION") ===  "PRINT"){
            localStorage.removeItem("REDIRECT_ACTION");
            handleClick();
        }

    }, []);

    return (
         <button className={styles.viewBtn} onClick={handleClick} disabled={isLoading}>
                    {isLoading ? (
                        <>
                             Processing...
                        </>
                    ) : (
                        'Print Design'
                    )}
                </button>
    );
};

export default PrintLink;